(() => {
  var ODOCACHE = {};

  angular.module('app.components')
    .directive('odometer', ['$timeout', ($timeout) => {
      return {
        scope: {
          key: '@',
          value: '@',
          toFixed: '@',
          suffix: '@',
          diff: '@',
          splash: '@'
        },
        link: (scope, element, attrs) => {
          attrs.$observe('value', value => {
            const isDirty = !_.isUndefined(ODOCACHE[scope.key]) &&
              !_.isUndefined(value) &&
              ODOCACHE[scope.key] !== value;

            if (isDirty) {
              scope.diff = value - ODOCACHE[scope.key];
              scope.splash = true;

              $timeout(() => {
                scope.splash = false;
                ODOCACHE[scope.key] = value;
              }, TIME.DATA_SPLASH);
            } else if (value) {
              ODOCACHE[scope.key] = value;
            }
          });
        },
        template: `
          <span class="odometer">
            {{ value || 0 | customNumber : toFixed }}{{ suffix }}
            <span class="odometer-diff" ng-class="{ splash: splash }">
              {{ diff > 0 ? "+" : "" }}{{ diff | customNumber : toFixed }}{{ suffix }}
            </span>
          </span>`
      };
    }]);
})();
